<template>
	<div>
    <div class="state">
      <div :class="(indexNum == item.id) ? 'state_itemOne state_item' : 'state_item'"  :style="'background-image:url('+item.bgPic+');'"  v-for="(item, index) in listData" :key="item.text" @click="activeVal(item, index)">
          <h3 class="state_item_text">{{ item.text }}</h3>
					<span class="state_item_num">{{ item.num }}</span>
      </div>
    </div>
  </div>
</template>
<script>
	export default {
		// props: ["listData"],
		props:{
			// 循环的数据
			listData:{
				type: Array,
			},
			// 查询选中的参数
			changeVal:{
				type: String,
			}
   },
		data() {
			return {
				indexNum:"",
				bgList:[require('@/assets/img/state_bg1.png'),require('@/assets/img/state_bg2.png'),require('@/assets/img/state_bg3.png'),require('@/assets/img/state_bg4.png'),require('@/assets/img/state_bg5.png'),require('@/assets/img/state_bg6.png')]
			};
		},
		methods: {
			activeVal(val, index) {
				this.indexNum = val.id;
				this.$emit("changeActive", val.id);
			},
		},
		created(){
			this.listData.forEach((item,index)=>{
					if(this.bgList.length-1>=index){
						item.bgPic=this.bgList[index]
					}else{
						item.bgPic=this.bgList[index-(this.bgList.length)]
					}
			})
		},
		watch:{
			changeVal(val){
				this.indexNum = val;
			}
		}
	};
</script>
<style scoped>
	.state {
		/* height: 100px; */
		display: flex;
		align-items: center;
		justify-content: space-between;
    background-color: #f2f6f7;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
	}
	.state .state_item{
		margin-right: 10px;
		height: 100px;
		position: relative;
		flex: 1;
		cursor: pointer;
		border-radius: 15px;
	}
	.state .state_item:nth-last-child(1) {
		margin-right: 0;
	}
	.state_item_text{
		font-size: 16px;
		position: absolute;
		left: 6%;
		top: 13px;
		color: #666;
		font-weight:500 ;
	}
	.state_item .state_item_num {
		width: 15%;
		text-align: center;
    font-size: 28px;
    color: #666;
		position: absolute;
		top: 27px;
		right: 21%;
	}
	.state_itemOne  .state_item_num,.state_itemOne .state_item_text{
		color: #004593 !important;
	}
	.state_item{
			background-image:url("../../assets/img/state_bg1.png");
			background-size:100% 100%;
			background-repeat:no-repeat;
	}
</style>
